module.exports = __webpack_public_path__ + "img/8.37a0d393.png";